import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSection } from 'omni-package-react-core';
import { CheckboxItemControl, FormCol, FormRow, Modal, T2, useScopedSelector } from 'ia-react-core';
import TextWithModalLink from '../../../../components/_TextWithModalLink';
import { CommunicationPreferencesFormPageState } from '../../../../interfaces/CommunicationPreferencesFormPageState';
import { StyledCheckboxItemControlWrapper, StyledSafeHtml } from './TermsOfUseSection.styles';

export interface TermsOfUseSectionProps { }

const TermsOfUseSection: FC<TermsOfUseSectionProps> = () => {
  const { t } = useTranslation('CommunicationPreferencesFormPage');
  const formState = useScopedSelector((state: CommunicationPreferencesFormPageState) => state);

  return (
    <FormSection pb={12}>
      <Modal name="termsOfUseModal">
        <T2>{t('termsOfUse.modalTitle')}</T2>
        <StyledSafeHtml>{formState.termsOfUseContent}</StyledSafeHtml>
      </Modal>
      <FormRow>
        <FormCol>
          <StyledCheckboxItemControlWrapper>
            <CheckboxItemControl
              required
              name="termsOfUse"
              label={
                <TextWithModalLink
                  translation="CommunicationPreferencesFormPage"
                  sectionName="termsOfUse"
                  modalName="termsOfUseModal"
                />
              }
            />
          </StyledCheckboxItemControlWrapper>
        </FormCol>
      </FormRow>
    </FormSection>
  );
};

export default TermsOfUseSection;
